export const EventId = {
    ExchangeView: 'ExchangeView',
    ExchangeAssetSwap: 'ExchangeAssetSwap',
    ExchangeConfigureAssetSwap: 'ExchangeConfigureAssetSwap',
    ExchangeNoGas: 'ExchangeNoGas',
    ExchangeSwap: 'ExchangeSwap',
    ExchangeSwapUnavailableView: 'ExchangeSwapUnavailableView',
    ExchangeTemporaryUnavailableView: 'ExchangeTemporaryUnavailableView',
    ExchangeConfigureAssetSearchUnavailable: 'ExchangeConfigureAssetSearchUnavailable',
    ExchangeOnboardingScreenView: 'ExchangeOnboardingScreenView',
};
Object.setPrototypeOf(EventId, null);
const getExchangeAssetSwapEventData = ({ origin, success, error, }) => ({
    event: 'ExchangeAssetSwap',
    properties: {
        origin,
        success: !error,
        error: success ? undefined : error,
    },
});
const getExchangeConfigureAssetSwapEventData = ({ origin, }) => ({
    event: 'ExchangeConfigureAssetSwap',
    properties: {
        origin,
    },
});
const getExchangeNoGasEventData = (params) => ({
    event: 'ExchangeNoGas',
    properties: params,
});
const getExchangeViewEventData = (params) => ({
    event: 'ExchangeView',
    properties: params,
});
const getExchangeSwapData = (params) => ({
    event: 'ExchangeSwap',
    properties: params,
});
const getExchangeSwapUnavailableViewData = (params) => ({
    event: 'ExchangeSwapUnavailableView',
    properties: params,
});
const getExchangeTemporaryUnavailableViewData = () => ({
    event: EventId.ExchangeTemporaryUnavailableView,
});
const getExchangeConfigureAssetSearchUnavailableData = (params) => {
    const maxLength = 6;
    const content = params.content.slice(0, maxLength);
    return {
        event: EventId.ExchangeConfigureAssetSearchUnavailable,
        properties: {
            ...params,
            content,
        },
    };
};
const getExchangeOnboardingScreenViewData = (params) => ({
    event: EventId.ExchangeOnboardingScreenView,
    properties: params,
});
const getEventPayload = (eventId, data) => {
    switch (eventId) {
        case EventId.ExchangeView:
            return getExchangeViewEventData(data);
        case EventId.ExchangeAssetSwap:
            return getExchangeAssetSwapEventData(data);
        case EventId.ExchangeConfigureAssetSwap:
            return getExchangeConfigureAssetSwapEventData(data);
        case EventId.ExchangeNoGas:
            return getExchangeNoGasEventData(data);
        case EventId.ExchangeSwap:
            return getExchangeSwapData(data);
        case EventId.ExchangeSwapUnavailableView:
            return getExchangeSwapUnavailableViewData(data);
        case EventId.ExchangeTemporaryUnavailableView:
            return getExchangeTemporaryUnavailableViewData();
        case EventId.ExchangeConfigureAssetSearchUnavailable:
            return getExchangeConfigureAssetSearchUnavailableData(data);
        case EventId.ExchangeOnboardingScreenView:
            return getExchangeOnboardingScreenViewData(data);
        default:
            throw new Error(`Unknown exchange event: ${eventId}`);
    }
};
export default getEventPayload;
